import { Reveal } from "@/components/site/motion";

const CHAPTERS = [
  { n: "01", title: "Connect", body: "Bring learners, education providers and the wider ecosystem together on one connected platform." },
  { n: "02", title: "Simplify", body: "Reduce paperwork, duplication and delay across discovery, applications and admissions." },
  { n: "03", title: "Modernise", body: "Automation, intelligent workflows and human expertise modernise education infrastructure." },
];

export const Vision = () => (
  <section id="vision" data-testid="vision-section" className="relative overflow-hidden bg-ink py-28 sm:py-36 text-white">
    <div className="grain" />
    <div className="absolute inset-0 grid-bg opacity-[0.08]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-4xl">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Our Vision</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display font-extrabold tracking-tighter text-4xl sm:text-6xl leading-[1] text-white">
            Simplify. Connect.{" "}
            <span className="text-cobalt">Modernise education.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-white/70">
            OpenDegree is building a connected education ecosystem — linking learners with education providers,
            simplifying journeys, reducing administrative complexity and modernising how education is discovered,
            accessed and delivered.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <Reveal key={i} delay={i * 0.1} className="bg-ink p-8 sm:p-10" data-testid={`vision-chapter-${i}`}>
            <span className="font-display text-5xl font-black tracking-tighter text-white/15">{c.n}</span>
            <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-white">{c.title}</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/60">{c.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
